(function () {
    'use strict';

    angular
        .module('app.settings')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    /* @ngInject */
    function appRun(routerHelper) {             
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [           
            {
                state: 'settings.category',
                config: {
                    url: '/categories',
                    templateUrl: 'app/settings/category/settings.category.controller.html',
                    controller: 'UserCategoryController',
                    controllerAs: 'vm',
                    title: 'User Categories',
                    settings: {
                        isVisible: false,
                        nav: 4,
                        content: '<i class="fa "></i> User Categories'
                    },
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            }
        ];
    }
})();
